// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { useAppDispatch, useAppSelector } from "app/hooks";
import img_friends from "assets/images/other/friends.png";
import icon_check from "assets/images/svg/icon_check.svg";
import icon_close from "assets/images/svg/icon_close.svg";
import icon_copy from "assets/images/svg/icon_copy.svg";
import logo_2 from "assets/images/svg/logo_2.svg";
import { selectConfig } from "features/config/configReducer";
import { emptyTokenType } from "features/config/types";
import { connect as connectAction } from "features/wallet/connect";
import { selectWallet } from "features/wallet/walletReducer";
import React, { useEffect, useState } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Modal from "react-modal";
import cn from "services/cn";
import { configModal, myToast } from "services/utils";
import Button from "../Button";
import ShareTwitter from "./ShareTwitter";

const ModalGift: React.FC<{ onControlModal: () => void }> = ({ onControlModal: handleControlModal }) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [isCopy, setIsCopy] = useState<boolean>(false);
  const wallet = useAppSelector(selectWallet);
  const { isConnected, referralCode } = wallet;

  const config = useAppSelector(selectConfig);

  const { socials } = config;

  const dispatch = useAppDispatch();

  function control(): void {
    setIsShowModal(false);
    handleControlModal();
  }

  const connect = async () => {
    await dispatch(connectAction(emptyTokenType));
  };

  useEffect(() => {
    if (isCopy) {
      myToast("Copied successfully!", "success");
      const idTimeout_1 = setTimeout(() => {
        setIsCopy(false);
      }, 3500);
      return () => clearTimeout(idTimeout_1);
    }
  }, [isCopy]);

  return (
    <Modal
      isOpen={!isShowModal}
      style={configModal("rgba(0, 0, 0, 0.7)", 2)}
      contentLabel="Modal"
      onRequestClose={() => control()}
    >
      <aside
        className={cn("modal--gift p-4 max-w-[288px] md:max-w-[420px] min-h-[200px] bg-black text-white", {
          "md:max-w-[320px]": !isConnected,
        })}
      >
        <div className="flex items-center justify-between">
          <img src={logo_2} alt="Fewcha" title="Fewcha" className="w-[22px] h-[22px]" />
          <div className="w-10 h-10 rounded-full hover:bg-[#23262A] flex">
            <img
              onClick={() => control()}
              src={icon_close}
              alt="Close Gift"
              title="Close Gift"
              className="hover:cursor-pointer w-5 h-5 m-auto"
            />
          </div>
        </div>
        <article>
          <p className="py-4 text-[22px] font-bold leading-[120%]">Fewcha Referral Program</p>
          {isConnected && <img src={img_friends} alt="Friend" />}
          <p className="py-4">
            For each friend you refer you will <strong>earn 2% rewards</strong> from using your Referral Code!
          </p>
        </article>
        {!isConnected ? (
          <Button size="large" loading={wallet.loading} onClick={connect} block className="mx-auto">
            Connect Wallet to start
          </Button>
        ) : (
          <div className="rounded-2xl  link-refferal relative w-[256px] md:w-[388px] md:h-[60px] flex md:rounded-[114px] ">
            <div className="border-link py-4 md:py-0 flex flex-col md:flex-row items-center  gap-x-4 content bg-black w-[384px] md:h-[54px]  m-auto md:rounded-[114px] justify-center">
              <CopyToClipboard text={`${window.location.origin}/?ref=${referralCode}`} onCopy={() => setIsCopy(true)}>
                <p className="line px-1 max-w-[240px] text-center  md:w-[258px] hover:cursor-pointer">
                  {`${window.location.origin}/?ref=${referralCode}`}
                </p>
              </CopyToClipboard>

              <div className="ref-icon flex items-center gap-x-5 mt-8 md:mt-[unset] md:pl-4">
                <CopyToClipboard text={`${window.location.origin}/?ref=${referralCode}`} onCopy={() => setIsCopy(true)}>
                  <img
                    src={isCopy ? icon_check : icon_copy}
                    alt="Copy link"
                    title="Copy link"
                    className={`${isCopy ? "w-6 h-6 " : "w-7 h-7 "}  hover:cursor-pointer`}
                  />
                </CopyToClipboard>
                <ShareTwitter social={socials[1]} text={`${window.location.origin}/?ref=${referralCode}`} />
                {/* <Test /> */}
              </div>
            </div>
          </div>
        )}
      </aside>
    </Modal>
  );
};
export default ModalGift;
